export const FlagLTIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21_194)">
        <path
          d="M23.2539 16.1743C23.7363 14.8744 24.0003 13.4683 24.0003 12.0005C24.0003 10.5326 23.7363 9.1265 23.2539 7.82656L12.0003 6.78308L0.74673 7.82656C0.26434 9.1265 0.000339508 10.5326 0.000339508 12.0005C0.000339508 13.4683 0.26434 14.8744 0.74673 16.1743L12.0003 17.2178L23.2539 16.1743Z"
          fill="#6DA544"
        />
        <path
          d="M23.2538 7.82568C21.5582 3.25607 17.1597 -0.000427246 12.0001 -0.000427246C6.84056 -0.000427246 2.44205 3.25607 0.746532 7.82568H23.2538Z"
          fill="#FFDA44"
        />
        <path
          d="M12.0003 24.0008C17.1599 24.0008 21.5584 20.7443 23.2539 16.1747H0.746693C2.44221 20.7443 6.84072 24.0008 12.0003 24.0008Z"
          fill="#D80027"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_194">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
